import { Link } from 'react-router-dom';
import { MapPin } from 'lucide-react';
import SeoHead from '@/components/shared/SeoHead';
import PageHero from '@/components/shared/PageHero';

const STATES: { slug: string; name: string }[] = [
  { slug: 'alabama', name: 'Alabama' },
  { slug: 'alaska', name: 'Alaska' },
  { slug: 'arizona', name: 'Arizona' },
  { slug: 'arkansas', name: 'Arkansas' },
  { slug: 'california', name: 'California' },
  { slug: 'colorado', name: 'Colorado' },
  { slug: 'connecticut', name: 'Connecticut' },
  { slug: 'delaware', name: 'Delaware' },
  { slug: 'district-of-columbia', name: 'District of Columbia' },
  { slug: 'florida', name: 'Florida' },
  { slug: 'georgia', name: 'Georgia' },
  { slug: 'hawaii', name: 'Hawaii' },
  { slug: 'idaho', name: 'Idaho' },
  { slug: 'illinois', name: 'Illinois' },
  { slug: 'indiana', name: 'Indiana' },
  { slug: 'iowa', name: 'Iowa' },
  { slug: 'kansas', name: 'Kansas' },
  { slug: 'kentucky', name: 'Kentucky' },
  { slug: 'louisiana', name: 'Louisiana' },
  { slug: 'maine', name: 'Maine' },
  { slug: 'maryland', name: 'Maryland' },
  { slug: 'massachusetts', name: 'Massachusetts' },
  { slug: 'michigan', name: 'Michigan' },
  { slug: 'minnesota', name: 'Minnesota' },
  { slug: 'mississippi', name: 'Mississippi' },
  { slug: 'missouri', name: 'Missouri' },
  { slug: 'montana', name: 'Montana' },
  { slug: 'nebraska', name: 'Nebraska' },
  { slug: 'nevada', name: 'Nevada' },
  { slug: 'new-hampshire', name: 'New Hampshire' },
  { slug: 'new-jersey', name: 'New Jersey' },
  { slug: 'new-mexico', name: 'New Mexico' },
  { slug: 'new-york', name: 'New York' },
  { slug: 'north-carolina', name: 'North Carolina' },
  { slug: 'north-dakota', name: 'North Dakota' },
  { slug: 'ohio', name: 'Ohio' },
  { slug: 'oklahoma', name: 'Oklahoma' },
  { slug: 'oregon', name: 'Oregon' },
  { slug: 'pennsylvania', name: 'Pennsylvania' },
  { slug: 'rhode-island', name: 'Rhode Island' },
  { slug: 'south-carolina', name: 'South Carolina' },
  { slug: 'south-dakota', name: 'South Dakota' },
  { slug: 'tennessee', name: 'Tennessee' },
  { slug: 'texas', name: 'Texas' },
  { slug: 'utah', name: 'Utah' },
  { slug: 'vermont', name: 'Vermont' },
  { slug: 'virginia', name: 'Virginia' },
  { slug: 'washington', name: 'Washington' },
  { slug: 'west-virginia', name: 'West Virginia' },
  { slug: 'wisconsin', name: 'Wisconsin' },
  { slug: 'wyoming', name: 'Wyoming' },
];

/**
 * A–Z / geographic browse index of states so curated salary pages stay within
 * three clicks of home (SMART W5–6).
 */
const StatesIndex = () => {
  const year = new Date().getFullYear();

  return (
    <div className="min-h-screen bg-background">
      <SeoHead
        title={`Salaries by State A–Z (${year}) | Wage Atlas`}
        description="Browse official BLS OEWS salary data for every U.S. state and the District of Columbia."
        canonical="https://wageatlas.com/states/"
      />

      <PageHero
        badge={{ icon: MapPin, label: 'State Index' }}
        title="Salaries by State"
        subtitle={
          <>
            Open any state for top occupations, no-degree and entry-level rankings, and links into
            curated salary pages.
          </>
        }
      />

      <div className="container mx-auto px-4 py-8">
        <ul className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {STATES.map((state) => (
            <li key={state.slug} className="border rounded-lg p-4">
              <Link
                to={`/state/${state.slug}/`}
                className="font-semibold text-primary hover:underline"
              >
                {state.name}
              </Link>
              <div className="text-xs text-muted-foreground mt-2 space-x-3">
                <Link to={`/no-degree-jobs/${state.slug}/`} className="hover:underline">
                  No-degree jobs
                </Link>
                <Link
                  to={`/best-paying-entry-level/${state.slug}/`}
                  className="hover:underline"
                >
                  Entry-level
                </Link>
                <Link to={`/ai-economy-jobs/${state.slug}/`} className="hover:underline">
                  AI economy
                </Link>
              </div>
            </li>
          ))}
        </ul>

        <p className="text-sm text-muted-foreground mt-8">
          National figures and cost-of-living context:{' '}
          <Link to="/real-wages/" className="text-primary hover:underline">
            Real wages
          </Link>
          {' · '}
          <Link to="/occupations/" className="text-primary hover:underline">
            All occupations
          </Link>
        </p>
      </div>
    </div>
  );
};

export default StatesIndex;
